<template>
    <div class="transfer-news">
        <div class="row">
            <div class="col-12">
                <div v-if="isLoading">
                    <p class="text-center" style="margin: 50px">
                        Laden...
                    </p>
                </div>
                <div v-else-if="news.length > 0">
                    <div
                        class="card mb-1"
                        :key="newsItem.id"
                        v-for="newsItem in news"
                    >
                        <div class="card-body d-flex justify-content-between">
                            <div>
                                <h6 class="card-title d-flex align-items-center">
                                    <span
                                        v-if="newsItem.type == 1"
                                        class="badge text-bg-info me-2"
                                    >Nieuwsbrief</span>
                                    <span
                                        v-else
                                        class="badge text-bg-warning me-2"
                                    >Nieuwsbericht</span>
                                    <span class="text-bold">{{ this.$moment(newsItem.created_at).format('dd D MMMM YYYY') }}</span>
                                </h6>
                                <p
                                    class="card-text"
                                    style="white-space: pre-line"
                                >{{ newsItem.title }}</p>
                            </div>
                            <div v-on:click="viewNews(newsItem)">
                                <icon name="look-into"></icon>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="alert alert-info" role="alert">
                        Geen nieuwsberichten of nieuwsbrieven gevonden.
                    </div>
                </div>
            </div>
        </div>
        <modal v-if="showNewsModal">
            <template v-slot:header>
                <h3 class="modal-title">
                    {{newsView?.title}}
                </h3>
            </template>
            <template v-slot:body>
                <div>
                    <div :key="index" v-for="(block, index) in newsView?.blocks">
                        <div class="example-viewer-dialog-text" v-if="block.type === 'text'">
                            <toast-ui-editor
                                :model-value="block.content"
                                :view-mode="true" />
                        </div>
                        <div v-if="block.type === 'image'">
                            <img class="example-viewer-dialog-image w-100" v-if="block.fileVersionHash"
                                 :src="apiUrlV3 + '/news/media/' + block.fileVersionHash + '?token=' + $store.getters.imageToken"/>
                        </div>
                        <div v-if="block.type === 'file'">
                            <template v-if="block.files">
              <span :key="file.fileVersionHash" v-for="file in block.files">
                <a target="_blank" :href="apiUrlV3 + '/news/downloads/' + file.fileVersionHash + '?token=' + $store.getters.imageToken">
                  <i class="fa-light fa-paperclip"></i> {{ file.name }}
                </a>
              </span>
                            </template>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <div>
                    <button type="button" class="btn btn-outline-info" @click="showNewsModal = false">sluiten</button>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/Modal';
import ToastUiEditor from '@/components/ToastUiEditor';
import Icon from "@/components/Icon.vue";

export default {
    name: 'TransferNews',
    components: {
        Modal,
        ToastUiEditor,
        Icon
    },
    data() {
        return {
            isLoading: false,
            news: [],
            showNewsModal: false,
            newsView: [],
            viewerOptions: {
                hideModeSwitch: true,
                usageStatistics: false,
            },
            apiUrlV3: process.env.VUE_APP_API_V3_URL,
        }
    },
    created() {
        this.getNews()
    },
    methods: {
        getNews() {
            this.isLoading = true;
            this.$request.get('/news?id_group=' + this.$store.getters.selectedGroupsQueryString)
                .then((response) => {
                    if (response) {
                        this.news = response
                    } else {
                        this.news = []
                    }
                    this.isLoading = false
                })
        },
        viewNews(newsItem) {
            this.showNewsModal = true
            this.newsView = null;
            this.$request.get('/news/'+ newsItem.id)
                .then((response) => {
                    if (response) {
                        this.newsView = response
                    } else {
                        this.newsView = []
                    }
                })
        }
    }
}
</script>

<style scoped>
</style>
